var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSheild = function SvgSheild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.272 3.905c.08-.686.497-1.253 1.171-1.402C4.496 2.27 6.536 2 10.333 2c3.798 0 5.838.27 6.89.503.675.15 1.092.716 1.171 1.402.12 1.039.273 2.748.273 4.762 0 3.762-1.986 7.281-5.33 9.003-1.118.575-2.208.997-3.004.997s-1.885-.422-3.003-.997C3.985 15.948 2 12.428 2 8.667c0-2.014.152-3.723.272-4.762",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.6 6.462a2.402 2.402 0 0 1 4.8 0l.049 1.119.057.005c.67.058 1.141.523 1.192 1.192.03.394.052.926.052 1.639s-.022 1.245-.052 1.639c-.05.67-.523 1.134-1.192 1.192-.54.047-1.34.086-2.506.086s-1.966-.04-2.506-.086c-.67-.058-1.141-.523-1.192-1.192-.03-.394-.052-.926-.052-1.639 0-.651.016-1.152.038-1.534.042-.724.543-1.239 1.263-1.303zm3.134.074.043.97a46 46 0 0 0-1.554 0l.043-.97a.735.735 0 0 1 1.468 0m.1 3.464c0 .341-.205.634-.498.763l.059.522c.014.129-.007.27-.123.327a.6.6 0 0 1-.272.055.6.6 0 0 1-.271-.055c-.117-.057-.138-.198-.123-.327l.058-.522a.834.834 0 1 1 1.17-.763",
    clipRule: "evenodd"
  })));
};
export default SvgSheild;